// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2KyYH","errorLogs":"styles_errorLogs__2lb8M"};